import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { ShieldCheck, AlertTriangle } from "lucide-react";

const Section = ({ title, children }) => (
  <div className="mb-6">
    <h4 className="font-display text-lg font-semibold mb-2 text-foreground">{title}</h4>
    <div className="text-sm text-muted-foreground space-y-1.5 leading-relaxed">{children}</div>
  </div>
);

export const GuaranteeModal = ({ open, onOpenChange }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="guarantee-modal"
        className="max-w-2xl max-h-[85vh] overflow-y-auto no-scrollbar"
      >
        <DialogHeader>
          <div className="flex items-center gap-3 mb-1">
            <div className="h-10 w-10 rounded-xl bg-primary/10 flex items-center justify-center">
              <ShieldCheck className="h-5 w-5 text-primary" />
            </div>
            <DialogTitle className="font-display text-xl">The sarkarijobai Success Guarantee</DialogTitle>
          </div>
          <DialogDescription className="sr-only">
            Eligibility-based money-back guarantee terms. Draft content pending legal review.
          </DialogDescription>
        </DialogHeader>

        <div className="flex items-center gap-2 rounded-lg border border-amber-400/40 bg-amber-400/10 px-3 py-2 text-xs font-semibold text-amber-600 dark:text-amber-400 mb-5">
          <AlertTriangle className="h-4 w-4 shrink-0" />
          DRAFT — FINAL TERMS REQUIRE LEGAL REVIEW
        </div>

        <p className="text-sm text-muted-foreground mb-6 leading-relaxed">
          Follow the sarkarijobai preparation program, complete the required milestones, and if you meet
          the eligibility criteria but don't achieve the defined qualifying outcome, you may be eligible
          for a refund. The following is placeholder content to be replaced by legally reviewed terms.
        </p>

        <Section title="Eligibility">
          <p>To be considered for the guarantee, a customer may be required to satisfy objective conditions, which may include:</p>
          <ul className="list-disc pl-5 pt-1 space-y-1">
            <li>A minimum active subscription period.</li>
            <li>Completion of the daily study time you selected at the start.</li>
            <li>Required study activity and consistency.</li>
            <li>Required mock-test participation.</li>
            <li>Required task / milestone completion.</li>
            <li>A required, genuine attempt at the target exam.</li>
            <li>Any other objective conditions defined in the final published policy.</li>
          </ul>
        </Section>

        <Section title="Qualifying outcome">
          <p>
            The "qualifying outcome" is a specific, measurable result that will be defined in the final
            published policy (placeholder — to be finalised with legal review). It is not a promise of
            rank, selection, admission or government employment.
          </p>
        </Section>

        <Section title="Refund process">
          <p>
            Eligible claims require verification of the eligibility conditions above. Approved refunds are
            processed to the original payment method within a defined window stated in the final policy.
          </p>
        </Section>

        <Section title="Exclusions">
          <p>Circumstances that do not qualify may include:</p>
          <ul className="list-disc pl-5 pt-1 space-y-1">
            <li>Not meeting the minimum usage / activity requirements.</li>
            <li>Not attempting the target exam.</li>
            <li>Requests outside the defined claim window.</li>
            <li>Violation of the terms of service or misuse of the platform.</li>
            <li>Any other exclusions defined in the final published policy.</li>
          </ul>
        </Section>

        <p className="text-xs text-muted-foreground border-t border-border pt-4">
          Disclaimer: Final guarantee terms are subject to the published policy. sarkarijobai does not
          guarantee government employment, rank or selection, and does not claim any fixed success rate.
          Eligibility conditions apply and not every customer will qualify for a refund.
        </p>
      </DialogContent>
    </Dialog>
  );
};
